import { Panel, PanelGroup, PanelResizeHandle } from "react-resizable-panels";
import OperationList from "./operationList/OperationList";
import Header from "./Header";
import ExtractedInfo from "./ExtractedInfo";
import BottomBar from "./BottomBar";
import { useFetchPart } from "@/lib/queries/hooks";
import FileDisplay from "./FileDisplay";

const engineeringDrawingWidthPercentage = 57;

export default function Part() {
  const { data: part } = useFetchPart();
  if (!part) return null;

  return (
    <div className="w-full h-full flex flex-col">
      <PanelGroup direction="horizontal" autoSaveId="persistence">
        <Panel defaultSize={100 - engineeringDrawingWidthPercentage}>
          <div className="h-full flex flex-col gap-1 px-4 pt-2">
            <Header part={part} />
            <ExtractedInfo />
            <OperationList part={part} />
            <BottomBar part={part} />
          </div>
        </Panel>
        <PanelResizeHandle className="w-0.25 bg-slate-300" />
        <Panel
          defaultSize={engineeringDrawingWidthPercentage}
          minSize={20}
          maxSize={80}
        >
          <FileDisplay key={part.id} />
        </Panel>
      </PanelGroup>
    </div>
  );
}
